import { useEffect, useState } from 'react';
import { Code2, Heart, ArrowUp } from 'lucide-react';
import { readData } from '@/firebase/database';
import { SITE_ROUTES } from '@/config/site-routes';

const SOCIAL_ICONS: Record<string, JSX.Element> = {
  github: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/></svg>,
  linkedin: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>,
  twitter: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/></svg>,
  x: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4l11.733 16h4.267l-11.733 -16h-4.267z"/><path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"/></svg>,
  facebook: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>,
  instagram: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>,
  youtube: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19.1c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.43z"/><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"/></svg>,
  dribbble: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"/></svg>,
  email: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  tiktok: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/></svg>,
  discord: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M18.8 4A19.6 19.6 0 0 0 14.2 3a14 14 0 0 0-.6 1.2 18.3 18.3 0 0 0-5.2 0A14 14 0 0 0 7.8 3a19.6 19.6 0 0 0-4.6 1c-3 4.3-3.8 8.5-3.4 12.6A19.7 19.7 0 0 0 5.8 20a14.5 14.5 0 0 0 1.2-2 12.8 12.8 0 0 1-2-.9l.5-.4a14 14 0 0 0 12 0l.5.4a12.8 12.8 0 0 1-2 .9 14.5 14.5 0 0 0 1.2 2 19.7 19.7 0 0 0 6-3.4c.5-4.8-.8-9-3.4-12.6zM8.3 14.7a1.7 1.7 0 0 1 0-3.4 1.7 1.7 0 0 1 0 3.4zm7.4 0a1.7 1.7 0 0 1 0-3.4 1.7 1.7 0 0 1 0 3.4z"/></svg>,
  telegram: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/></svg>,
  whatsapp: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>,
};

interface NavLink {
  label: string;
  href: string;
  order?: number;
}

interface FooterData {
  brandName: string;
  brandTagline: string;
  copyrightText: string;
  availabilityStatus: string;
  availabilitySubtext: string;
  responseTime: string;
  statusText1: string;
  statusText2: string;
  socials?: Record<string, { platform: string; url: string }>;
  navLinks?: Record<string, NavLink>;
  githubUrl?: string;
  linkedinUrl?: string;
  twitterUrl?: string;
  emailUrl?: string;
}

const defaultFooter: FooterData = {
  brandName: 'Mustakim.dev',
  brandTagline: 'Building exceptional digital experiences. Available for freelance & full-time opportunities.',
  copyrightText: 'Mustakim Nur Salin',
  availabilityStatus: 'Available for freelance',
  availabilitySubtext: 'Currently accepting new projects',
  responseTime: 'Within 24 hours',
  statusText1: 'Available for work',
  statusText2: 'Open to remote positions',
};

// Real internal page links from the central site-routes config.
// Adding a new page in src/config/site-routes.ts auto-adds it to the footer
// AND the sitemap — important so Google can discover and index every page.
const defaultNavLinks: NavLink[] = SITE_ROUTES.map((r) => ({
  label: r.label,
  href: r.path,
}));

const Footer = () => {
  const [footer, setFooter] = useState<FooterData>(defaultFooter);
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  useEffect(() => {
    readData('footer').then((data) => {
      if (data) setFooter({ ...defaultFooter, ...data });
    });
  }, []);

  // Dynamic nav links from Firebase or fallback to defaults
  const links: NavLink[] = footer.navLinks
    ? Object.values(footer.navLinks).sort((a, b) => (a.order ?? 999) - (b.order ?? 999))
    : defaultNavLinks;

  const socialLinks: { platform: string; url: string }[] = footer.socials
    ? Object.values(footer.socials)
    : [
        ...(footer.githubUrl ? [{ platform: 'GitHub', url: footer.githubUrl }] : []),
        ...(footer.linkedinUrl ? [{ platform: 'LinkedIn', url: footer.linkedinUrl }] : []),
        ...(footer.twitterUrl ? [{ platform: 'Twitter', url: footer.twitterUrl }] : []),
        ...(footer.emailUrl ? [{ platform: 'Email', url: footer.emailUrl }] : []),
      ];

  const handleNavClick = (e: React.MouseEvent, href: string) => {
    // If it's a hash link on the same page, smooth scroll
    if (href.startsWith('#')) {
      e.preventDefault();
      document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
    }
    // Otherwise let the browser handle it (external or page links)
  };

  return (
    <footer className="relative border-t border-border/40 overflow-hidden pb-20 lg:pb-0">
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background to-transparent pointer-events-none" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-primary/20 to-transparent" />

      <div className="relative container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-10 mb-10 sm:mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="p-1.5 rounded-lg border border-primary/20">
                <Code2 size={18} className="text-primary" />
              </div>
              <span className="font-display font-bold text-base sm:text-lg gradient-text">{footer.brandName}</span>
            </div>
            <p className="text-muted-foreground text-xs sm:text-sm leading-relaxed mb-5">{footer.brandTagline}</p>
            <div className="flex gap-3 relative z-10">
              {socialLinks.map(({ platform, url }) => (
                <a key={platform} href={url} target="_blank" rel="noopener noreferrer" aria-label={platform}
                  className="p-2 rounded-lg border border-border/60 hover:border-primary/30 bg-muted/30 text-muted-foreground hover:text-foreground transition-all duration-300 cursor-pointer"
                  style={{ pointerEvents: 'auto' }}>
                  {SOCIAL_ICONS[platform.toLowerCase()] || <span className="text-xs font-mono">{platform.slice(0, 2)}</span>}
                </a>
              ))}
            </div>
          </div>

          {/* Nav — Dynamic */}
          <nav aria-label="Footer navigation">
            <h4 className="font-mono font-semibold text-xs sm:text-sm mb-4 sm:mb-5 text-primary tracking-wider uppercase">Navigation</h4>
            <div className="grid grid-cols-2 gap-2">
              {links.map((link) => (
                <a key={link.label} href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-muted-foreground hover:text-foreground transition-colors duration-200 text-xs sm:text-sm font-mono flex items-center gap-1 py-0.5">
                  <span className="text-primary/30 text-xs" aria-hidden="true">&rsaquo;</span>
                  {link.label}
                </a>
              ))}
            </div>
          </nav>

          {/* Status */}
          <div>
            <h4 className="font-mono font-semibold text-xs sm:text-sm mb-4 sm:mb-5 text-primary tracking-wider uppercase">Status</h4>
            <div className="space-y-3 mb-4">
              <div className="flex items-center gap-2.5 text-xs sm:text-sm">
                <div className="w-2 h-2 rounded-full bg-primary animate-pulse flex-shrink-0" />
                <span className="text-foreground/80">{footer.statusText1}</span>
              </div>
              <div className="flex items-center gap-2.5 text-xs sm:text-sm">
                <div className="w-2 h-2 rounded-full bg-muted-foreground flex-shrink-0" />
                <span className="text-muted-foreground">{footer.statusText2}</span>
              </div>
            </div>
            <div className="glass border border-border/60 rounded-xl p-3 sm:p-4 bg-muted/20">
              <p className="text-[10px] sm:text-xs font-mono text-muted-foreground mb-1">Response time</p>
              <p className="text-xs sm:text-sm font-bold text-primary">{footer.responseTime}</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-border/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-muted-foreground/70 text-xs sm:text-sm font-mono flex items-center gap-2">
            Made with <Heart size={13} className="text-muted-foreground/50 fill-muted-foreground/50" aria-hidden="true" /> by {footer.copyrightText}&nbsp;
            © {new Date().getFullYear()}
          </p>

          <div className="flex items-center gap-4">
            <button onClick={scrollToTop} className="flex items-center gap-2 text-xs font-mono text-muted-foreground/60 hover:text-foreground transition-colors duration-300 group" aria-label="Back to top">
              Back to top
              <div className="p-1.5 rounded-lg border border-border/40 group-hover:border-primary/30 transition-colors duration-300">
                <ArrowUp size={12} />
              </div>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
